module.exports = __webpack_public_path__ + "img/33.7c0a6116.jpg";